// export const api_url = "http://localhost:5000";
// export const api_url = "https://frrlancejobportapi.onrender.com";
// export const api_url = "https://api.jskbook.com";

export const api_url = "https://api.ambeworlds.com";